





































import { defineComponent } from '@vue/composition-api';
import { useDgaServices, statusBadges } from './dga-services.hook';
import ServicesTable from './components/ServicesTable.vue';
import { DgaServicesPageInformation } from '../../components/utils/useCustomerPageInformation.hooks';
import { MIGRATION } from '@ligo/dashboard/customer/store';
import ServiceTypeCard from './components/ServicesTypesCard.vue';

export default defineComponent({
  name: 'DgaServicesHandler',
  components: { ServicesTable, ServiceTypeCard },
  setup() {
    const { t, isReady, load } = DgaServicesPageInformation;
    load();

    const {
      services,
      loadingServices,
      types,
      loadingTypes,
      tablePagination,
      search
    } = useDgaServices();

    const goToDga = () => {
      window.open(MIGRATION.DGA_SALARY_ADMIN, '_blank');
    };

    return {
      services,
      loadingServices,
      types,
      loadingTypes,
      tablePagination,
      statusBadges,
      t,
      isReady,
      search,
      goToDga
    };
  }
});
